import React from "react";
import { useMediaQuery } from "@mui/material";
import { LineChart } from "@mui/x-charts/LineChart";

export default function Chart({ chartData }) {
  const isMobile = useMediaQuery("(max-width: 600px)");
  if (!chartData || Object.keys(chartData).length === 0) {
    console.warn("⚠️ Chart data is missing!");
    return null;
  }
  const uData = Array.isArray(chartData?.Resultat) ? chartData.Resultat : [];
  const xLabels = Array.isArray(chartData?.DataResultat)
    ? chartData.DataResultat
    : [];
  const rangeState = Array.isArray(chartData?.RangeState)
    ? chartData.RangeState
    : [];

  return (
    <LineChart
      width={isMobile ? 250 : 700}
      height={225}
      xAxis={[{ scaleType: "point", data: xLabels }]}
      series={[
        {
          data: uData,
          type: "line",
          curve: "linear",
          label: "резултати",
          showMark: true,
          valueFormatter: (value) => `${value}`,
          // area: true,
        },
      ]}
      // tooltip={{ trigger: "item" }}
    ></LineChart>
  );
}
